'use client'

import Autoplay from 'embla-carousel-autoplay'

// Components
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { HomeProjectCard } from '@/app/[lang]/(home)/_components/projects/project-card'

// Types
import type { Project } from '@/lib/generated/prisma/client'
import type { Locale } from '@/i18n-config'
import type { Dictionary } from '@/types/global'

export function HomeProjectCarousel({
  projects,
  lang,
  dictionary,
}: {
  projects: Project[] | null
  lang: Locale
  dictionary: Dictionary
}) {
  return (
    <div className="relative w-full col-span-3 p-3">
      <Carousel
        plugins={[
          Autoplay({
            delay: 4000,
            stopOnInteraction: true,
            stopOnMouseEnter: true,
          }),
        ]}
        opts={{
          align: 'start',
          loop: true,
          // dragFree: true,
        }}
        className="w-full max-w-full"
      >
        <CarouselContent className="-ml-2 md:-ml-4">
          {projects &&
            Array.from(projects).map((project, index) => (
              <CarouselItem
                key={project.id || index}
                className="pl-2 basis-[100%] sm:basis-1/2 md:basis-1/2 md:pl-4 lg:basis-1/3 2xl:basis-1/4"
              >
                <HomeProjectCard
                  lang={lang}
                  project={project}
                  dictionary={dictionary}
                  priority={index < 3}
                />
              </CarouselItem>
            ))}
        </CarouselContent>
        <CarouselPrevious className="left-2 z-10 bg-white/90 backdrop-blur-sm border-gray-200 hover:bg-white md:left-4 lg:-left-12 hidden md:block" />
        {/* <CarouselNext className="right-2 z-10 bg-white/90 backdrop-blur-sm border-gray-200 hover:bg-white md:right-4 lg:-right-12" /> */}
      </Carousel>
    </div>
  )
}
